import Service from "../../../Services/index";

const Position = {
    namespaced: true,
    state: {
        data: [],
        form: {
            id: null,
            name: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_POSITION: (state, res) => {
            state.data = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_POSITION_BY_ID: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM_DATA: (state) => {
            state.form = {
                id: null,
                name: "",
            }
        }
    },
    actions: {
        setPosition({commit}, page = 1) {
            return Service.Position.getPosition(page).then(data => {
                commit("GET_POSITION", data);
            });
        },
        savePosition({commit}, data) {
            if (!data.id) {
                return Service.Position.createPosition(data).then(res => {
                    //console.log("create");
                });
            } else {
                return Service.Position.updatePosition(data.id, data).then(res => {
                    //console.log("update");
                });
            }
        },
        showPositionByID({commit}, id) {
            return Service.Position.showPosition(id).then(res => {
                commit("GET_POSITION_BY_ID", res);
            })
        },
        delete({commit}, id) {
            return Service.Position.deletePosition(id)
                .catch(err => {
                    console.error(err);
                });
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
    }
};

export default Position;
